import type {CSSProperties} from 'react';
import {font, radius, weight} from '../scale.js';
import {wedgeExactRole} from './wedgeRoles.js';

export type WedgePhoneFieldVariant = 'wedge-phone' | 'wedge-phone-code';

/* Released text-briefing fields of the Settings phone screen: a full-width native input on the surface fill with the card
   border, off-scale padding, 12px radius and 16px type. It sets no outline of its own (the shipped Wedge sheet draws the
   focus ring) and no minimum height. The code field adds a 6px track, centered text and bold type. Each reads the exact
   legacy roles, so the shipped ink rules and the host theme variables keep matching. */
const FIELD_PY = 13, FIELD_PX = 14, CODE_TRACK = 6;

export function wedgePhoneFieldStyle(variant: WedgePhoneFieldVariant): CSSProperties {
  return {
    width: '100%', padding: `${FIELD_PY}px ${FIELD_PX}px`, background: wedgeExactRole('surface'),
    border: `1px solid ${wedgeExactRole('cardBorder')}`, borderRadius: radius.lg, fontSize: font.headline,
    color: wedgeExactRole('label'), fontFamily: wedgeExactRole('font'), outline: 0, boxSizing: 'border-box',
    ...(variant === 'wedge-phone-code' ? {letterSpacing: CODE_TRACK, textAlign: 'center', fontWeight: weight.bold} : {}),
  };
}
